import fun from "../../util/util";
import myConst from "@/util/my-const";
export default {
    namespaced:true,
    state:{
        photovoltaicSysMenu:"", //光伏系统的菜单
    },
    mutations:{
         
        
        //设置光伏系统的菜单
        setPhotovoltaicSysMenu(state,menu){
            state.photovoltaicSysMenu = menu
            localStorage.setItem(myConst.keyPhotovoltaicSysMenuList, JSON.stringify(menu));
        },
        clearPhotovoMenu(state){
            state.photovoltaicSysMenu = ""
        }

    },
    getters:{
                 
        //获取光伏系统的菜单数据
        getPhotovoltaicSysMenu(state){
            state.photovoltaicSysMenu = JSON.parse(localStorage.getItem(myConst.keyPhotovoltaicSysMenuList));
            return state.photovoltaicSysMenu 
        },
    }

}